import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ShipService } from '../../services/ship.service';
import { Ship } from '../../Ship';
import { EntitlementService } from '../../services/entitlement.service';

@Component({
  selector: 'app-ship-details',
  templateUrl: './ship-details.component.html',
  styleUrls: ['./ship-details.component.css']
})
export class ShipDetailsComponent implements OnInit {
  @ViewChild('dropdown', { static: false }) dropdown: ElementRef;
  @Input() shipData: Ship;
  @Input() shipResultArray: Ship[];
  @Output() newShipSelectedEmitter = new EventEmitter<Ship>();
  commissionedState = '';

  constructor(
    private shipService: ShipService,
    private entitlementService: EntitlementService
  ) {}

  ngOnInit() {
    this.commissionedState =
      this.shipData.isDecommissioned === 'N'
        ? 'Commissioned'
        : 'Decommissioned';
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  newShipSelected(newShipData: Ship) {
    this.shipData = newShipData;
    this.shipService.storeShipProfile(this.shipData);
    this.newShipSelectedEmitter.emit(this.shipData);
  }
}
